import { ServiceProps } from '../types';

export class Services {
  values: ServiceProps[] = [];

  add(service: ServiceProps) {
    if (service.type === 'mandatory') {
      throw new Error("mandatory can't have services");
    }

    this.values.push(service);
  }

  enable(serviceKeys: string | string[]) {
    if (typeof serviceKeys === 'string') {
      serviceKeys = [serviceKeys];
    }

    serviceKeys.forEach((serviceKey) => {
      const currentService = this.values.find((service) => service.key === serviceKey);
      if (currentService) {
        if (currentService.enabled) {
          console.warn(`Service ${serviceKey} already enabled`);
        }
        currentService.enabled = true;
      } else {
        throw new Error(`Service ${serviceKey} doesn't exist`);
      }
    });
  }

  disable(serviceKeys: string | string[]) {
    if (typeof serviceKeys === 'string') {
      serviceKeys = [serviceKeys];
    }

    serviceKeys.forEach((serviceKey) => {
      const currentService = this.values.find((service) => service.key === serviceKey);
      if (currentService) {
        if (!currentService.enabled) {
          console.warn(`Service ${serviceKey} already disabled`);
        }
        currentService.enabled = false;
      } else {
        throw new Error(`Service ${serviceKey} doesn't exist`);
      }
    });
  }
}
